import { render } from "./ReturnReasonComponent.vue?vue&type=template&id=9f035302"
import script from "./ReturnReasonComponent.vue?vue&type=script&lang=js"
export * from "./ReturnReasonComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ReturnReason/ReturnReasonComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f035302"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f035302', __exports__)) {
    api.reload('9f035302', __exports__)
  }
  
  module.hot.accept("./ReturnReasonComponent.vue?vue&type=template&id=9f035302", () => {
    api.rerender('9f035302', render)
  })

}


export default __exports__